/**
 * The current AVV/DPA document version, published as a static PDF under
 * public/docs/. Bump the filename together with the version strings in the
 * legal.dpa locale content when a new version is released (OS-235: previous
 * versions stay in git and are provided on request).
 */
export const DPA_PDF_PATH = '/docs/avv-open-sourced-v1.1-de.pdf'

/**
 * The current SLA document version, published like the AVV (OS-445). The PDF
 * is the rendered `/de/sla` page exported with `npm run sla:pdf` against a
 * running dev server. Bump the filename together with the version strings in
 * the legal.sla locale content and re-export when a new version is released.
 */
export const SLA_PDF_PATH = '/docs/sla-open-sourced-v1.1-de.pdf'
